import React, { Fragment } from 'react';
import { AiOutlineInfoCircle, AiOutlinePhone } from "react-icons/ai";
import { Link } from 'react-router-dom';
import LT from '../../../images/localtotal.png';
import Mesa01 from '../../../images/Mesas/p2.jpg';
import Mesa02 from '../../../images/Mesas/p4.jpg';

import './table.css';

export default function Table() {

    return (
        <Fragment>

            <div className="app-all">
                <div className="image-total">
                    <span> <AiOutlineInfoCircle title="Informações Gerais" size="24px" />Observações</span>
                    <span>As Reservas são feitas por agendamento, então solicite seu agendamento
                        abaixo!
                    </span>
                    <span>Obervação: As reservas de mesas com mais de 4 lugares,
                        será preciso entrar em contato com o estabelecimento
                    </span>
                    <span><AiOutlinePhone size="28px" title="(45)3268-8745" color="blue" />(45)3268-8745</span>
                    <img src={LT} alt="imagem 01"></img>
                </div>

                <div className='container-table'>
                    <div className="image-table">
                        <h4>Mesa Num 1</h4>
                        <img src={Mesa02} title="info info info" alt="imagem"></img>
                        <div className="button-table">
                             <Link to='/terminal' state={{ nome: 'Mesa01' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status</h4>
                        </div>
                    </div>

                    <div className="image-table">
                        <h4>Mesa Num. 2</h4>
                        <img src={Mesa02} title="info" alt="imagem 01"></img>
                        <div className="button-table">
                            <Link to='/terminal' state={{ nome: 'Mesa 02' }} >
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa02"
                                    name="mesa 02"
                                >

                                    <span>Reservar</span>

                                </button>
                            </Link>
                            <h4>Status Mesa</h4>
                        </div>
                    </div>

                    <div className="image-table">
                        <h4>Mesa Num. 3</h4>
                        <img src={Mesa02} alt="imagem 01"></img>
                        <div className="button-table">
                            <Link to='/terminal' state={{ nome: 'Mesa 03' }} >
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa03"
                                    name="mesa 03"
                                >

                                    <span>Reservar</span>

                                </button>
                            </Link>
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 4</h4>
                        <img src={Mesa01} alt="imagem 04"></img>
                        <div className="button-table">
                            <Link to='/terminal' state={{ nome: 'Mesa 04' }} >
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa04"
                                    name="mesa 04"
                                >

                                    <span>Reservar</span>

                                </button>
                            </Link>
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 5</h4>
                        <img src={Mesa01} title="info info info" alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa05' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 6</h4>
                        <img src={Mesa01} title="info" alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa06' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                </div>

                <div className='container-table'>

                    <div className="image-table">
                        <h4>Mesa Num. 7</h4>
                        <img src={Mesa02} alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa06' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 8</h4>
                        <img src={Mesa01} alt="imagem 05"></img>
                        <div className="button-table">
                            <Link to='/terminal' state={{ nome: 'Mesa 08' }} >
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa05"
                                    name="mesa 05"
                                /* onClick={handlerClick} */
                                >

                                    <span>Reservar</span>

                                </button>
                            </Link>
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 9</h4>
                        <img src={Mesa01} title="info" alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa09' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 10</h4>
                        <img src={Mesa02} title="info" alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa010' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 11</h4>
                        <img src={Mesa01} title="info" alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa011' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                    <div className="image-table">
                        <h4>Mesa Num. 12</h4>
                        <img src={Mesa02} title="info" alt="imagem 01"></img>
                        <div className="button-table">
                        <Link to='/terminal' state={{ nome: 'Mesa012' }} > 
                                <button
                                    className="btn btn-three"
                                    type="button"
                                    value="mesa01"
                                    name="mesa01"

                                >
                                    
                                    <span>Reservar</span>

                                </button>
                             </Link> 
                            <h4>Status Mesa</h4>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    )

}